export default {
  methods: {
    saveCurrentPage(pagination) {
      localStorage.setItem(
        'current_pagination',
        JSON.stringify(pagination)
      );
    },
    removeData() {
      localStorage.removeItem('current_pagination');
    },
    recoverPagination() {
      const paginate = localStorage.getItem('current_pagination');
      if (paginate) {
        const data = JSON.parse(paginate);
        this.pagination = data;
      } else {
        this.getList();
      }
    },
  },
  beforeRouteLeave(to, _, next) {
    const module = this.$options.name.split('-')[0];
    if (!to.name.includes(module)) {
      this.removeData();
    }
    next();
  },
  beforeMount() {
    this.recoverPagination();
  }
};
